import React, { Component } from 'react';
import { Button,Panel } from 'react-bootstrap';
import $ from 'jquery';

import FilterWordsBar from './Test_FilterWordBar';
import WordTable from './Test_WordTable';
import OtherWords from './Test_OtherWords';

class SubmitBar extends Component {
  constructor(props) {
    super(props);
    this.handleCheckClick = this.handleCheckClick.bind(this);
    this.handleWrongWordChange = this.handleWrongWordChange.bind(this);
  }
  handleCheckClick(event) {
    this.props.onCheckClick(event);
  }
  handleWrongWordChange(event) {
    this.props.onWrongWordChange(event);
  }
  render() {
    return (
      <form>
        <Button onClick={this.handleCheckClick} >
          {this.props.answered ?'再来一次':'检查'}
        </Button>
        { this.props.answered && <span><input type="checkbox" defaultChecked={! this.props.bingo} onChange={this.handleWrongWordChange} />只显示错词</span> }
      </form>
    );
  }
}

class Test extends Component {
  /* 初始化 */
  constructor(props) {
    super(props);
    this.state = {
      answered: false,
      answers: [],
      test_words: [],
      other_words: [],
      results: [],
      grades: [],
      grade: -1,
      units: [],
      unit: -1,
      words: [],
      only_repeat_wrong_word: false,
      bingo: true, /* 全部答对 */
    }
    this.handleWordInputChange = this.handleWordInputChange.bind(this);
    this.handleCheckClick = this.handleCheckClick.bind(this);
    this.handleGradeOnChange = this.handleGradeOnChange.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleWrongWordChange = this.handleWrongWordChange.bind(this);
    this.onWrongWordCheckClick = this.onWrongWordCheckClick.bind(this);
  }
  /* 获取年级数据 */
  componentDidMount() {
    var that = this;
    const url = URL+'api/grads/';
    $(function(){$.ajax({
      headers:{
        'Content-Type':'application/json',
      },
      url: url,
      type:"GET",
      dataType:"json",
      data:{},
      success: function(data){
        that.setState({grades:data,})
      },
      error: function(xhr, status,err){
        console.log(err.Message);
      },
    })})
  }
  /* 年级选择的相应事件 */
  handleGradeOnChange(event) {
    var that = this;
    this.setState({
      grade:event.target[event.target.selectedIndex].id,
      unit: -1,
      words: [],
      test_words: [],
      answers: [],
    })
    const url = URL+'api/units/'+event.target[event.target.selectedIndex].id+'/';
    $(function(){$.ajax({
      headers:{
        'Content-Type':'application/json',
      },
      url: url,
      type: "GET",
      dataType: "json",
      data: {},
      success: function(result){
        that.setState({units:result,})
      },
      error: function(xhr, status, error){
        /*var err = eval("(" + xhr.responseText + ")");*/
        console.log(error.Message);
      }
    })})
  }
  /* 单元选择的相应事件 */
  handleUnitChange(event) {
    this.setState({
      unit:event.target[event.target.selectedIndex].id,
      answered: false,
      words: [],
      test_words: [],
      answers: [],
      results: [],
      repeated: false,
      bingo: true,
    });
    var id = event.target[event.target.selectedIndex].id;
    var that = this;
    const url = URL+'api/words/'+ id + '/';
    $(function(){$.ajax({
      headers:{
        'Content-Type':'application/json',
      },
      url: url,
      type: "GET",
      dataType: "json",
      data: {},
      success: function(result){
        that.setState({words:result,});
        var rs=[];
	var others=[];
        var test_words=[];
        result.forEach((r)=>{
          if (r.is_main){
            rs.push({'id':r.id,result:false});
            test_words.push(r);
          } else {
            others.push(r);
	  }
        });
        that.setState({results:rs,test_words:test_words,other_words:others,})
      },
      error: function(xhr, status, error){
        console.log(error.Message);
      }
    })})
  }
  /* 单词输入框修改的响应事件 */
  handleWordInputChange(event) {
    const id = parseInt(event.target.id,10);
    var val = event.target.value.trim();
    var answers = this.state.answers;
    if (answers.find(answer=>answer.id===id)){
      answers.find(answer=>answer.id===id).answer=val;
    } else {
      answers.push({'id':id,'answer':val});
    }
    this.setState({answers:answers,});
    var results;
    if (this.state.test_words.find(test_word=>test_word.id===id).english===val){
      results = this.state.results;
      results.find(result=>result.id===id).result=true;
      this.setState({results:results,})
    } else {
      results = this.state.results;
      results.find(result=>result.id===id).result=false;
      this.setState({results:results,})
    }
    if (event.target.value.length>val.length) {
      //console.log(event.target.ref);
    }
  }
  /* 检查&再试一次的相应事件 */
  handleCheckClick(event) {
    event.preventDefault();
    if (event.target.innerHTML==='检查'){
      var bingo = true;
      this.state.results.forEach((result)=>{
        if (!result.result){
          bingo = false;
        }
      });
      this.setState({answered:true,bingo:bingo,only_repeat_wrong_word:!bingo,}) ;
      var that = this;
      if (this.props.isLogin){
        $(function(){$.ajax({
          url: URL+'api/test_records_add/',
          headers:{
            'Authorization':'JWT '+that.props.token,
          },
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(that.state.results),
          success: function(result){
            //console.log('success!')
          },
          error: function(xhr,status,error) {
              console.log(status,error.toString());
              //that.setState({username:'',password:'',isLogin:false,token:'',});
              alert('上传检查记录出错，错误信息：'+status+error);
          }
        })})
      }
    } else { /* 再来一次 */
      if (!this.state.only_repeat_wrong_word){
        const words = this.state.words;
        var words1 = [];
        var results1 = [];
        words.forEach((word)=>{
          if (word.is_main) {
            words1.push(word);
            results1.push({'id':word.id,'result':false})
          }
        });
        this.setState({test_words:words1,results:results1,answered:false,})
      } else {
        if (this.state.only_repeat_wrong_word && !this.state.bingo) {
          var tmp_words = [];
          this.state.test_words.forEach((word)=>{
            if (!(this.state.results.find(result=>result.id===word.id).result)){
              tmp_words.push(word);
            }
          });
          var results = [];
          tmp_words.forEach((tmp_word)=>{
            results.push({'id':tmp_word.id,result:false})
          });
          this.setState({test_words:tmp_words,answered:false,results:results,});
          }
        }
      }
  }
  /* 检查重复测试时是否只包括错误的词多选框 */
  handleWrongWordChange(event) {
    this.setState({only_repeat_wrong_word:event.target.checked,})
  }
  /* 错词抽查响应 */
  onWrongWordCheckClick(event) {
    event.preventDefault();
    this.setState({answered:false,unit:-1,});
    var that = this;
    $(function(){$.ajax({
          url: URL+'api/get_wrong_words/',
          headers:{
            'Authorization':'JWT '+that.props.token,
          },
          type: 'GET',
          data: {},
          contentType: 'application/json',
          success: function(result){
            var temp_results = [];
            result.forEach((r)=>{
              temp_results.push({'id':r.id,'result':false})
            })
            that.setState({answered:false,words:result,test_words:result,results:temp_results,answers:[],})
          },
          error: function(xhr,status,error) {
              console.log(status,error.toString());
              that.setState({username:'',password:'',isLogin:false,token:'',});
              alert('登录已过期，请重新登录');
          }
    })})
  }
  /* 渲染 */
  render() {
    return(<div>
      <Panel>
        <Panel.Heading>
          <FilterWordsBar
            categories={this.state.grades}
            units={this.state.units}
            isLogin={this.props.isLogin}
            username={this.props.username}
            onGradeChange={this.handleGradeOnChange}
            onUnitChange={this.handleUnitChange}
            onWrongWordCheckClick={this.onWrongWordCheckClick}
          />
        </Panel.Heading>
        <Panel.Body>
          <WordTable
            test_words={this.state.test_words}
            answers={this.state.answers}
            answered={this.state.answered}
            only_repeat_wrong_word={this.state.only_repeat_wrong_word}
            onWordInputChange={this.handleWordInputChange}
          />
        </Panel.Body>
        <Panel.Footer>
          { this.state.test_words.length>0
          &&
          <SubmitBar
            answered={this.state.answered}
            only_repeat_wrong_word={this.state.only_repeat_wrong_word}
            bingo={this.state.bingo}
            onCheckClick={this.handleCheckClick}
            onWrongWordChange={this.handleWrongWordChange}
          />
          }
        </Panel.Footer>
      </Panel>
      { (((this.state.answered)||(this.state.test_words.length===0)) && (this.state.unit>0)) ? (<OtherWords data={this.state.other_words} />):'' }
      </div>
    )
  }
}

export default Test;



// WEBPACK FOOTER //
// ./src/Test.js